export type HookQueryOptions = {
  skip?: boolean;
};

export const queryKey = (scope: string, payload?: unknown) => {
  if (payload === undefined) {
    return scope;
  }

  try {
    return `${scope}:${JSON.stringify(payload)}`;
  } catch {
    return scope;
  }
};
